import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import debounce from "lodash.debounce";

import GenericTableComponent from "../common/Table";
import {
  getPayments
} from "../../redux/slices/billingSlice";

const columns = [
  //{ id: "name", label: "Advertiser" },
  { id: "billingMonth", label: "Billing Month" },
  { id: "paidAt", label: "Payment Date" },
  { id: "amountPaid", label: "Amount Paid" },
  { id: "status", label: "Approval" },
];
const AllBilling = () => {
  const dispatch = useDispatch();
  const { payments, meta, loading } = useSelector(
    (state) => state.billing
  );

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const partyType = "ADVERTISER"
  useEffect(() => {
    dispatch(getPayments({ page, rowsPerPage, partyType: partyType }));
  }, [dispatch, page, rowsPerPage, partyType]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    dispatch(getPayments({ page: newPage, rowsPerPage, partyType: partyType }));
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    dispatch(getPayments({ page: 0, rowsPerPage: newRowsPerPage, partyType: partyType }));
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((searchTerm) => {
        dispatch(getPayments({ page: 0, rowsPerPage, name: searchTerm, partyType: partyType }));
      }, 2000),
    [dispatch, rowsPerPage, partyType]
  );

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearch(value);
    debouncedSearch(value);
  };

  const triggerSearch = () => {
    dispatch(getPayments({ page: 0, rowsPerPage, name: search, partyType: partyType }));
  };

  return (
    <div>
      {loading ? (
        <div> </div>
      ) : (
        <GenericTableComponent
          columns={columns}
          data={payments}
          //filterSearch={true}
          paginate={true}
          user
          hideSelector
          page={page}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          triggerSearch={triggerSearch}
          search={search}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handleSearchChange={handleSearchChange}
          totalItems={meta?.itemCount || 0}
        />
      )}
    </div>
  );
};

export default AllBilling;